import "./style.css";
import Header from "../../../componente/header";
import { useState, useEffect } from "react";
import api from "../../../services/api";
import Modal from "react-modal";

function Caixa() {
  const { DateTime } = require("luxon");

  const [showform, setshowform] = useState(false);

  const dt = new Date();
  const dtt11 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");
  let time =
    dt.getHours().toString().padStart(2, "0") +
    ":" +
    dt.getMinutes().toString().padStart(2, "0");
  let dtcadastro = dtt11 + " " + time;

  const date1 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    "01";

  const date2 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");

  const date11 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    "01";

  const date22 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");

  const [titulo, settitulo] = useState(true);
  const [despesa, setdespesa] = useState(false);

  const [dt1, setdt1] = useState(date1);
  const [dt2, setdt2] = useState(date2);

  const [dt11, setdt11] = useState(date11);
  const [dt22, setdt22] = useState(date22);

  const [abusca, setabusca] = useState("");
  const [abusca2, setabusca2] = useState("");

  const [listatitulo, setlistatitulo] = useState([]);
  const [listadespesa, setlistadespesa] = useState([]);

  const [listabanco, setlistabanco] = useState([]);

  const [codbanco, setcodbanco] = useState(0);

  const [totalreceber, settotalreceber] = useState(0);
  const [totalrecebido, settotalrecebido] = useState(0);

  const [totalpagar, settotalpagar] = useState(0);
  const [totalpago, settotalpago] = useState(0);

  const [baixatotal, setbaixatotal] = useState(false);

  const [listabanco2, setlistabanco2] = useState([]);
  const [listamoeda, setlistamoeda] = useState([]);

  const [codigo, setcodigo] = useState(0);
  const [valor, setvalor] = useState(0);
  const [codbanco2, setcodbanco2] = useState(0);
  const [codmoeda, setcodmoeda] = useState(0);

  useEffect(() => {
    function ListarTitulo() {
      api
        .get("/v1/operacoes/caixa/titulo", {
          params: {
            busca: abusca,
            dt1,
            dt2,
            codbanco,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistatitulo(response.data);

          api
            .get("/v1/operacoes/caixa/totaltituloreceber", {
              params: {
                codbanco,
              },
              headers: {
                Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
              },
            })
            .then(function (response) {
              settotalreceber(response.data.total);
            })
            .catch(function (err) {
              console.log("ops! ocorreu um erro: " + err);
            });

          api
            .get("/v1/operacoes/caixa/totaltitulorecebido", {
              params: {
                codbanco,
              },
              headers: {
                Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
              },
            })
            .then(function (response) {
              settotalrecebido(response.data.total);
            })
            .catch(function (err) {
              console.log("ops! ocorreu um erro: " + err);
            });
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }
    ListarTitulo();
  }, [abusca, dt1, dt2, codbanco, titulo, showform]);

  useEffect(() => {
    function ListarDespesa() {
      api
        .get("/v1/operacoes/caixa/despesa", {
          params: {
            busca: abusca2,
            dt1: dt11,
            dt2: dt22,
            codbanco,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistadespesa(response.data);

          api
            .get("/v1/operacoes/caixa/totaldespesapagar", {
              params: {
                codbanco,
              },
              headers: {
                Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
              },
            })
            .then(function (response) {
              settotalpagar(response.data.total);
            })
            .catch(function (err) {
              console.log("ops! ocorreu um erro: " + err);
            });

          api
            .get("/v1/operacoes/caixa/totaldespesapago", {
              params: {
                codbanco,
              },
              headers: {
                Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
              },
            })
            .then(function (response) {
              settotalpago(response.data.total);
            })
            .catch(function (err) {
              console.log("ops! ocorreu um erro: " + err);
            });
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }
    ListarDespesa();
  }, [abusca2, dt11, dt22, codbanco, despesa, showform]);

  useEffect(() => {
    function ListarBanco() {
      api
        .get("/v1/operacoes/caixa/banco", {
          params: {
            busca: "",
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistabanco(response.data);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }
    ListarBanco();
  }, []);

  useEffect(() => {
    function ListarBanco2() {
      api
        .get("/v1/cadastro/banco", {
          params: {
            busca: "",
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistabanco2(response.data);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }
    ListarBanco2();
  }, []);

  useEffect(() => {
    function ListarMoeda() {
      api
        .get("/v1/cadastro/moeda", {
          params: {
            busca: "",
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistamoeda(response.data);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }
    ListarMoeda();
  }, []);

  function FormataData(props) {
    return props
      ? DateTime.fromISO(props).plus({ hours: 3 }).toFormat("dd/MM/yyyy")
      : null;
  }

  function FormataDataHora(props) {
    return props
      ? DateTime.fromISO(props)
          .plus({ hours: 3 })
          .toFormat("dd/MM/yyyy HH:mm:ss")
      : null;
  }

  function closeModal() {
    setshowform(false);
  }

  function Salvar() {
    titulo
      ? api
          .post(
            "/v1/operacoes/caixa/baixatitulo",
            {
              baixatotal: baixatotal ? "S" : "N",
              codcontasreceber: codigo,
              codbanco: codbanco2,
              codmoeda,
              valor,
              dtlancamento: dtcadastro,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
              },
            }
          )
          .then(() => {
            setshowform(false);
          })
          .catch(function (err) {
            console.log("ops! ocorreu um erro: " + err);
          })
      : api
          .post(
            "/v1/operacoes/caixa/baixadespesa",
            {
              baixatotal: baixatotal ? "S" : "N",
              codcontaspagar: codigo,
              codbanco: codbanco2,
              codmoeda,
              valor,
              dtlancamento: dtcadastro,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
              },
            }
          )
          .then(() => {
            setshowform(false);
          })
          .catch(function (err) {
            console.log("ops! ocorreu um erro: " + err);
          });
  }

  function openModal(item) {
    titulo ? setcodigo(item.codcontasreceber) : setcodigo(item.codcontaspagar);
    setcodbanco2(item.codbanco);
    setcodmoeda(item.codmoeda);
    setvalor(item.vlliquido);
    setbaixatotal(true);

    setshowform(true);
  }

  return (
    <>
      <Header />

      <div>
        <Modal
          isOpen={showform}
          onRequestClose={closeModal}
          overlayClassName="modal-overlay"
          className="modal-content modal-xl"
        >
          <div className="container-fluid h-75">
            <div className="row">
              {baixatotal ? (
                <h2>
                  Baixa Total - {titulo ? "Título: " : "Despesa: "} {codigo}
                </h2>
              ) : (
                <h2>
                  Baixa Parcial - {titulo ? "Título: " : "Despesa: "} {codigo}
                </h2>
              )}
            </div>
            <div className="row">
              <hr />
            </div>

            <div className="row mb-3">
              <div className="col-6">
                {baixatotal ? (
                  <button
                    className="btn btn-primary w-100"
                    onClick={() => setbaixatotal(true)}
                  >
                    Baixa Total
                  </button>
                ) : (
                  <button
                    className="btn btn-secondary w-100"
                    onClick={() => setbaixatotal(true)}
                  >
                    Baixa Total
                  </button>
                )}
              </div>

              <div className="col-6">
                {baixatotal ? (
                  <button
                    className="btn btn-secondary w-100"
                    onClick={() => setbaixatotal(false)}
                  >
                    Baixa Parcial
                  </button>
                ) : (
                  <button
                    className="btn btn-primary w-100"
                    onClick={() => setbaixatotal(false)}
                  >
                    Baixa Parcial
                  </button>
                )}
              </div>
            </div>

            <div className="row">
              <form>
                <div className="row">
                  <div className="col-6">
                    <label htmlFor="caixa" className="form-label">
                      Caixa/Banco
                    </label>
                    <select
                      id="caixa"
                      className="form-select"
                      value={codbanco2}
                      onChange={(e) => setcodbanco2(e.target.value)}
                    >
                      <option value="0">Escolha o banco ou Caixa</option>
                      {listabanco2.map(function (ban) {
                        return (
                          <option key={ban.codbanco} value={ban.codbanco}>
                            {ban.banco}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-6">
                    <label htmlFor="moeda" className="form-label">
                      Condição de Pagamento
                    </label>
                    <select
                      id="moeda"
                      className="form-select"
                      value={codmoeda}
                      onChange={(e) => setcodmoeda(e.target.value)}
                    >
                      <option value="0">Escolha a condição de pagamento</option>
                      {listamoeda.map(function (moe) {
                        return (
                          <option key={moe.codmoeda} value={moe.codmoeda}>
                            {moe.moeda}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="row">
                    <div className="col-sm-3">
                      <label htmlFor="valor" className="form-label">
                        Valor
                      </label>
                      <input
                        type="number"
                        id="valor"
                        className="form-control"
                        placeholder="Nome do banco"
                        value={valor}
                        onChange={(e) => setvalor(e.target.valueAsNumber)}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div className="row">
              <div className="col-12 mt-3 d-flex justify-content-end">
                <button className="btn btn-danger ms-4" onClick={closeModal}>
                  Cancelar
                </button>
                <button className="btn btn-success ms-4" onClick={Salvar}>
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>

      <div className="row">
        <div className="ms-4">
          <h1>Caixa</h1>
        </div>
        <p className="ms-4">
          Rotina do caixa, para fazer as baixas de títulos e despesas em aberto.
        </p>
        <hr />
      </div>

      <div className="row mb-3">
        <div className="col-2"></div>
        <div className="col-4">
          <button
            className="btn btn-primary w-100"
            onClick={(e) => {
              settitulo(true);
              setdespesa(false);
            }}
          >
            Títulos
          </button>
        </div>

        <div className="col-4">
          <button
            className="btn btn-danger w-100"
            onClick={(e) => {
              settitulo(false);
              setdespesa(true);
            }}
          >
            Despesas
          </button>
        </div>
      </div>

      <div className="row">
        <div className="col-3">
          <div className="ms-2">
            <div className="row">
              {titulo ? <h2>Titulo em Aberto</h2> : <h2>Despesa em Aberto</h2>}
            </div>

            <label htmlFor="caixa" className="form-label">
              Caixa
            </label>
            <select
              id="caixa"
              className="form-select"
              value={codbanco}
              onChange={(e) => setcodbanco(e.target.value)}
            >
              <option value="0">Escolha o banco ou Caixa</option>
              {listabanco.map(function (ban) {
                return (
                  <option key={ban.codbanco} value={ban.codbanco}>
                    {ban.banco}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <div className="col-9">
          <div className="row d-flex justify-content-end">
            <div className="col-4">
              {titulo ? (
                <div className="card bg-danger mb-3">
                  <div className="card-header d-flex justify-content-center branco">
                    Valor Para Receber
                  </div>
                  <div className="card-body d-flex justify-content-center branco">
                    <h2>
                      {totalreceber.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </h2>
                  </div>
                </div>
              ) : (
                <div className="card bg-danger mb-3">
                  <div className="card-header d-flex justify-content-center branco">
                    Valor Para Pagar
                  </div>
                  <div className="card-body d-flex justify-content-center branco">
                    <h2>
                      {totalpagar.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </h2>
                  </div>
                </div>
              )}
            </div>

            <div className="col-4">
              {titulo ? (
                <div className="card bg-success mb-3">
                  <div className="card-header d-flex justify-content-center branco">
                    Valor Recebido
                  </div>
                  <div className="card-body d-flex justify-content-center branco">
                    <h2>
                      {totalrecebido.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </h2>
                  </div>
                </div>
              ) : (
                <div className="card bg-success mb-3">
                  <div className="card-header d-flex justify-content-center branco">
                    Valor Pago
                  </div>
                  <div className="card-body d-flex justify-content-center branco">
                    <h2>
                      {totalpago.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </h2>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {titulo ? (
        <div className="row ms-2">
          <div className="col-sm-5">
            <label className="form-label form-check-label" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código ou caixa/banco"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca}
              onChange={(e) => setabusca(e.target.value)}
            />
          </div>

          <div className="col-sm-2">
            <label htmlFor="periodo" className="form-label">
              Dt. Início
            </label>
            <br />
            <input
              type="date"
              id="periodo"
              className="form-control"
              placeholder="Data Inicio"
              value={dt1}
              onChange={(e) => setdt1(e.target.value)}
            />
          </div>

          <div className="col-sm-2">
            <label htmlFor="periodo" className="form-label">
              Dt. Fim
            </label>
            <br />
            <input
              type="date"
              id="periodo2"
              className="form-control"
              placeholder="dtnascimento"
              value={dt2}
              onChange={(e) => setdt2(e.target.value)}
            />
          </div>
        </div>
      ) : (
        <div className="row ms-2">
          <div className="col-sm-5">
            <label className="form-label form-check-label" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código ou caixa/banco"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca2}
              onChange={(e) => setabusca2(e.target.value)}
            />
          </div>

          <div className="col-sm-2">
            <label htmlFor="periodo" className="form-label">
              Dt. Início
            </label>
            <br />
            <input
              type="date"
              id="periodo"
              className="form-control"
              placeholder="Data Inicio"
              value={dt11}
              onChange={(e) => setdt11(e.target.value)}
            />
          </div>

          <div className="col-sm-2">
            <label htmlFor="periodo" className="form-label">
              Dt. Fim
            </label>
            <br />
            <input
              type="date"
              id="periodo2"
              className="form-control"
              placeholder="dtnascimento"
              value={dt22}
              onChange={(e) => setdt22(e.target.value)}
            />
          </div>
        </div>
      )}

      <div className="row mt-3">
        <hr />
      </div>

      <div className="row">
        {titulo ? (
          <div className="m-2">
            <table className="table table-hover fonte">
              <thead>
                <tr>
                  <th className="codigo">Código</th>
                  <th className="parcela">Parcela</th>
                  <th className="lancamento">Lançamento</th>
                  <th className="vencimento">Vencimento</th>
                  <th className="cliente">Cliente</th>
                  <th className="valor">Valor</th>
                  <th className="hitorico">Histórico</th>
                  <th className="banco">Banco</th>
                  <th className="moeda">Moeda</th>
                  <th className="acao">Ações</th>
                </tr>
              </thead>
              <tbody>
                {listatitulo.map(function (item) {
                  return (
                    <tr key={item.codcontasreceber}>
                      <th>{item.codcontasreceber}</th>
                      <th>{item.parcela}</th>
                      <th>{FormataDataHora(item.dtlancamento)}</th>
                      <th>{FormataData(item.dtvencimento)}</th>
                      <th>{item.nome}</th>
                      <th>{item.vlliquido}</th>
                      <th>{item.historico}</th>
                      <th>{item.banco}</th>
                      <th>{item.moeda}</th>
                      <th>
                        <div className="d-flex justify-content-center">
                          <button
                            className="btn fa-solid fa-receipt"
                            onClick={() => openModal(item)}
                          ></button>
                        </div>
                      </th>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan={5}>
                    Quantidade de Registros: {listatitulo.length}
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        ) : (
          <div className="m-2">
            <table className="table table-hover fonte">
              <thead>
                <tr>
                  <th className="codigo">Código</th>
                  <th className="parcela">Parcela</th>
                  <th className="lancamento">Lançamento</th>
                  <th className="vencimento">Vencimento</th>
                  <th className="cliente">Nome</th>
                  <th className="valor">Valor</th>
                  <th className="hitorico">Histórico</th>
                  <th className="banco">Banco</th>
                  <th className="moeda">Moeda</th>
                  <th className="acao">Ações</th>
                </tr>
              </thead>
              <tbody>
                {listadespesa.map(function (item) {
                  return (
                    <tr key={item.codcontaspagar}>
                      <th>{item.codcontaspagar}</th>
                      <th>{item.parcela}</th>
                      <th>{FormataDataHora(item.dtlancamento)}</th>
                      <th>{FormataData(item.dtvencimento)}</th>
                      <th>{item.nome}</th>
                      <th>{item.vlliquido}</th>
                      <th>{item.historico}</th>
                      <th>{item.banco}</th>
                      <th>{item.moeda}</th>
                      <th>
                        <div className="d-flex justify-content-center">
                          <button
                            className="btn fa-solid fa-receipt"
                            onClick={() => openModal(item)}
                          ></button>
                        </div>
                      </th>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan={5}>
                    Quantidade de Registros: {listatitulo.length}
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>
    </>
  );
}

export default Caixa;
